import { faCheck, faLink, faSync } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button } from '@domain-group/suit-theme'

import { useSetState } from '@domain-group/react-hooks'

import { digObject } from '@domain-group/javascript-utils'

import useAccountingIntegration from '@hooks/useAccountingIntegration'
import useInvoice from '@hooks/useInvoice'

import handleCallbackAction from '@functions/handleCallbackAction'

import type { InvoiceModel } from '@domain-group/realhub-backend-api-types'

const defaultState = {
  loading: false,
}

type InvoiceActionButtonProps = {
  accountingPayload: ReturnType<typeof useAccountingIntegration>,
  invoice: InvoiceModel,
}

const InvoiceActionButton = (props: InvoiceActionButtonProps) => {
  const {
    accountingPayload: { hasActiveSession },
    invoice,
  } = props

  const [state, setState] = useSetState(defaultState)
  const { loading } = state

  const invoicePayload = useInvoice(invoice)
  const {
    callbacks: {
      approveInvoice: approveFn,
      createInvoiceOnAccountingApi: createFn,
      syncExternalInvoice: syncFn,
    },
    invoice: {
      approved,
    },
  } = invoicePayload

  const getSyncData = digObject(invoice, 'data.xero_id', false)
  const isSynced = !!getSyncData

  const createInvoicePayload = {
    callbacks: {
      action: createFn,
      afterAction: () => setState({ loading: false }),
      afterError: () => setState({ loading: false }),
    },
    toastText: 'Invoice Created',
  }

  const syncExternalInvoice = {
    callbacks: {
      action: syncFn,
      afterAction: () => setState({ loading: false }),
      afterError: () => setState({ loading: false }),
    },
    toastText: 'Invoice Synced',
  }

  const approveInvoicePayload = {
    callbacks: {
      action: approveFn,
      afterAction: () => setState({ loading: false }),
      afterError: () => setState({ loading: false }),
    },
    toastText: 'Invoice Approved',
  }

  return (
    <>
      {!approved && (
        <Button
          buttonStyle="secondaryCreate"
          icon={<FontAwesomeIcon icon={faCheck} />}
          loading={loading}
          onClick={() => {
            setState({ loading: true })
            // @ts-expect-error TS2345
            handleCallbackAction(approveInvoicePayload)
          }}
          size="small"
        >
          Approve
        </Button>
      )}

      {approved && hasActiveSession && !isSynced && (
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faLink} />}
          loading={loading}
          onClick={() => {
            setState({ loading: true })
            // @ts-expect-error TS2345
            handleCallbackAction(createInvoicePayload)
          }}
          size="small"
          // @ts-expect-error TS2322
          fontSize="xsmall"
        >
          Create in Xero
        </Button>
      )}

      {approved && hasActiveSession && isSynced && (
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faSync} />}
          loading={loading}
          onClick={() => {
            setState({ loading: true })
            // @ts-expect-error TS2345
            handleCallbackAction(syncExternalInvoice)
          }}
          size="small"
          // @ts-expect-error TS2322
          fontSize="xsmall"
        >
          Sync
        </Button>
      )}
    </>
  )
}

export default InvoiceActionButton
